<template>
    <modal
            :linkClass="'action-icon'"
            :modalId="name"
            :title="title"
            :modalSize="'large'"
            :footer="true"
    >
        <template slot="modalBody">
            <div class="form-group">
                <form v-on:submit.prevent="$emit('saveChanges')">
                    <label :for="name+'-name'">Naam</label>
                    <input v-validate="'required'"
                           :name="name+'-name'"
                           :id="name+'-name'"
                           type="text"
                           class="form-control"
                           v-model="value.name">
                </form>
            </div>
            <div class="form-group">
                <label :for="name+'-department'">Department</label>
                <select v-model="value.department" class="form-control">
                    <option disabled value="">Please select one</option>
                    <option v-for="dep in departmentOptions" :value="dep" :key="dep">
                        {{dep}}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <vue-multi-select
                    ref="multiSelect"
                    v-model="value.rights"
                    search
                    historyButton
                    :options="options"
                    :filters="filters"
                    :btnLabel="btnLabel"
                    :selectOptions="selectOptions"
                >
                    <template v-slot:option="{option}">
                        <input type="checkbox" :checked="option.selected"/>
                        <span>{{option.name}}</span>
                    </template>
                </vue-multi-select>
            </div>
            <div class="form-group">
                {{ value.rights.map(r => r.name).join(', ') }}
            </div>
        </template>
        

        <div class="modal-footer" slot="modalFooter">
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
                Annuleren
            </button>
            <button type="button" class="btn btn-primary" :disabled="!value.name.length" @click="saveChanges" data-dismiss="modal">
                <i class="fal fa-save mr-2"></i> Opslaan
            </button>

        </div>
    </modal>
</template>

<script>
    import { RIGHTS } from '../../views/roles/rights';
    import vueMultiSelect from 'vue-multi-select';
    import 'vue-multi-select/dist/lib/vue-multi-select.css';
    import { DEPARTMENTS } from '../../constants';
    
    let sections = {}
    Object.keys(RIGHTS).forEach(r => {
        const entity = r.split('_')[0];
        if(sections[entity]) {
        sections[entity].list.push({name: r})
        } else {
        sections[entity] = {
            name: entity,
            list: [
            { name: r },
            ],
        }
        }
    })
  
    const options = Object.values(sections);

    export default {
        data() {
            return {
                btnLabel: values => `Rights selected (${values.length})`,
                selectOptions: options,
                departmentOptions: DEPARTMENTS,
                filters: [
                    {
                        nameAll: 'Select all',
                        nameNotAll: 'Deselect all',
                        func() {
                            return true;
                        },
                    },
                ],
                options: {
                    multi: true,
                    groups: true,
                },
            };
        },
        props: ['index', 'title', 'value', 'name'],
        methods: {
            saveChanges() {
                this.$emit('saveChanges', this.value);
            }
        },
        components: {
            vueMultiSelect,
        },
    }
</script>